/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from "./routes/__root"
import { Route as LayoutRouteImport } from "./routes/_layout"
import { Route as LayoutIndexRouteImport } from "./routes/_layout/index"
import { Route as LayoutSwapRouteImport } from "./routes/_layout/swap"
import { Route as LayoutPortfolioRouteImport } from "./routes/_layout/portfolio"
import { Route as LayoutDefiRouteImport } from "./routes/_layout/defi"
import { Route as LayoutStakingIndexRouteImport } from "./routes/_layout/staking.index"
import { Route as LayoutPortfolioIndexRouteImport } from "./routes/_layout/portfolio.index"
import { Route as LayoutDefiIndexRouteImport } from "./routes/_layout/defi.index"
import { Route as LayoutStakingAssetRouteImport } from "./routes/_layout/staking.$asset"
import { Route as LayoutPortfolioBreakdownRouteImport } from "./routes/_layout/portfolio.breakdown"
import { Route as LayoutPortfolioAssetsRouteImport } from "./routes/_layout/portfolio.assets"
import { Route as LayoutDefiStablecoinsRouteImport } from "./routes/_layout/defi.stablecoins"
import { Route as LayoutDefiProtocolsRouteImport } from "./routes/_layout/defi.protocols"
import { Route as LayoutDefiPortfolioRouteImport } from "./routes/_layout/defi.portfolio"
import { Route as LayoutStakingAssetIndexRouteImport } from "./routes/_layout/staking.$asset.index"
import { Route as LayoutDefiStablecoinsIndexRouteImport } from "./routes/_layout/defi.stablecoins.index"
import { Route as LayoutDefiProtocolsIndexRouteImport } from "./routes/_layout/defi.protocols.index"
import { Route as LayoutDefiPortfolioIndexRouteImport } from "./routes/_layout/defi.portfolio.index"
import { Route as LayoutStakingAssetUnstakeRouteImport } from "./routes/_layout/staking.$asset.unstake"
import { Route as LayoutStakingAssetStakeRouteImport } from "./routes/_layout/staking.$asset.stake"
import { Route as LayoutStakingAssetClaimRouteImport } from "./routes/_layout/staking.$asset.claim"
import { Route as LayoutDefiProtocolsProtocolKeyRouteImport } from "./routes/_layout/defi.protocols.$protocolKey"
import { Route as LayoutDefiPortfolioPositionsRouteImport } from "./routes/_layout/defi.portfolio.positions"
import { Route as LayoutDefiPortfolioOpportunitiesRouteImport } from "./routes/_layout/defi.portfolio.opportunities"
import { Route as LayoutDefiPoolTokenAddressProtocolIdRouteImport } from "./routes/_layout/defi.pool.$tokenAddress.$protocolId"

const LayoutRoute = LayoutRouteImport.update({
  id: "/_layout",
  getParentRoute: () => rootRouteImport,
} as any)
const LayoutIndexRoute = LayoutIndexRouteImport.update({
  id: "/",
  path: "/",
  getParentRoute: () => LayoutRoute,
} as any)
const LayoutSwapRoute = LayoutSwapRouteImport.update({
  id: "/swap",
  path: "/swap",
  getParentRoute: () => LayoutRoute,
} as any)
const LayoutPortfolioRoute = LayoutPortfolioRouteImport.update({
  id: "/portfolio",
  path: "/portfolio",
  getParentRoute: () => LayoutRoute,
} as any)
const LayoutDefiRoute = LayoutDefiRouteImport.update({
  id: "/defi",
  path: "/defi",
  getParentRoute: () => LayoutRoute,
} as any)
const LayoutStakingIndexRoute = LayoutStakingIndexRouteImport.update({
  id: "/staking/",
  path: "/staking/",
  getParentRoute: () => LayoutRoute,
} as any)
const LayoutPortfolioIndexRoute = LayoutPortfolioIndexRouteImport.update({
  id: "/",
  path: "/",
  getParentRoute: () => LayoutPortfolioRoute,
} as any)
const LayoutDefiIndexRoute = LayoutDefiIndexRouteImport.update({
  id: "/",
  path: "/",
  getParentRoute: () => LayoutDefiRoute,
} as any)
const LayoutStakingAssetRoute = LayoutStakingAssetRouteImport.update({
  id: "/staking/$asset",
  path: "/staking/$asset",
  getParentRoute: () => LayoutRoute,
} as any)
const LayoutPortfolioBreakdownRoute =
  LayoutPortfolioBreakdownRouteImport.update({
    id: "/breakdown",
    path: "/breakdown",
    getParentRoute: () => LayoutPortfolioRoute,
  } as any)
const LayoutPortfolioAssetsRoute = LayoutPortfolioAssetsRouteImport.update({
  id: "/assets",
  path: "/assets",
  getParentRoute: () => LayoutPortfolioRoute,
} as any)
const LayoutDefiStablecoinsRoute = LayoutDefiStablecoinsRouteImport.update({
  id: "/stablecoins",
  path: "/stablecoins",
  getParentRoute: () => LayoutDefiRoute,
} as any)
const LayoutDefiProtocolsRoute = LayoutDefiProtocolsRouteImport.update({
  id: "/protocols",
  path: "/protocols",
  getParentRoute: () => LayoutDefiRoute,
} as any)
const LayoutDefiPortfolioRoute = LayoutDefiPortfolioRouteImport.update({
  id: "/portfolio",
  path: "/portfolio",
  getParentRoute: () => LayoutDefiRoute,
} as any)
const LayoutStakingAssetIndexRoute = LayoutStakingAssetIndexRouteImport.update({
  id: "/",
  path: "/",
  getParentRoute: () => LayoutStakingAssetRoute,
} as any)
const LayoutDefiStablecoinsIndexRoute =
  LayoutDefiStablecoinsIndexRouteImport.update({
    id: "/",
    path: "/",
    getParentRoute: () => LayoutDefiStablecoinsRoute,
  } as any)
const LayoutDefiProtocolsIndexRoute =
  LayoutDefiProtocolsIndexRouteImport.update({
    id: "/",
    path: "/",
    getParentRoute: () => LayoutDefiProtocolsRoute,
  } as any)
const LayoutDefiPortfolioIndexRoute =
  LayoutDefiPortfolioIndexRouteImport.update({
    id: "/",
    path: "/",
    getParentRoute: () => LayoutDefiPortfolioRoute,
  } as any)
const LayoutStakingAssetUnstakeRoute =
  LayoutStakingAssetUnstakeRouteImport.update({
    id: "/unstake",
    path: "/unstake",
    getParentRoute: () => LayoutStakingAssetRoute,
  } as any)
const LayoutStakingAssetStakeRoute = LayoutStakingAssetStakeRouteImport.update({
  id: "/stake",
  path: "/stake",
  getParentRoute: () => LayoutStakingAssetRoute,
} as any)
const LayoutStakingAssetClaimRoute = LayoutStakingAssetClaimRouteImport.update({
  id: "/claim",
  path: "/claim",
  getParentRoute: () => LayoutStakingAssetRoute,
} as any)
const LayoutDefiProtocolsProtocolKeyRoute =
  LayoutDefiProtocolsProtocolKeyRouteImport.update({
    id: "/$protocolKey",
    path: "/$protocolKey",
    getParentRoute: () => LayoutDefiProtocolsRoute,
  } as any)
const LayoutDefiPortfolioPositionsRoute =
  LayoutDefiPortfolioPositionsRouteImport.update({
    id: "/positions",
    path: "/positions",
    getParentRoute: () => LayoutDefiPortfolioRoute,
  } as any)
const LayoutDefiPortfolioOpportunitiesRoute =
  LayoutDefiPortfolioOpportunitiesRouteImport.update({
    id: "/opportunities",
    path: "/opportunities",
    getParentRoute: () => LayoutDefiPortfolioRoute,
  } as any)
const LayoutDefiPoolTokenAddressProtocolIdRoute =
  LayoutDefiPoolTokenAddressProtocolIdRouteImport.update({
    id: "/pool/$tokenAddress/$protocolId",
    path: "/pool/$tokenAddress/$protocolId",
    getParentRoute: () => LayoutDefiRoute,
  } as any)

export interface FileRoutesByFullPath {
  "/defi": typeof LayoutDefiRouteWithChildren
  "/portfolio": typeof LayoutPortfolioRouteWithChildren
  "/swap": typeof LayoutSwapRoute
  "/": typeof LayoutIndexRoute
  "/defi/portfolio": typeof LayoutDefiPortfolioRouteWithChildren
  "/defi/protocols": typeof LayoutDefiProtocolsRouteWithChildren
  "/defi/stablecoins": typeof LayoutDefiStablecoinsRouteWithChildren
  "/portfolio/assets": typeof LayoutPortfolioAssetsRoute
  "/portfolio/breakdown": typeof LayoutPortfolioBreakdownRoute
  "/staking/$asset": typeof LayoutStakingAssetRouteWithChildren
  "/defi/": typeof LayoutDefiIndexRoute
  "/portfolio/": typeof LayoutPortfolioIndexRoute
  "/staking": typeof LayoutStakingIndexRoute
  "/defi/portfolio/opportunities": typeof LayoutDefiPortfolioOpportunitiesRoute
  "/defi/portfolio/positions": typeof LayoutDefiPortfolioPositionsRoute
  "/defi/protocols/$protocolKey": typeof LayoutDefiProtocolsProtocolKeyRoute
  "/staking/$asset/claim": typeof LayoutStakingAssetClaimRoute
  "/staking/$asset/stake": typeof LayoutStakingAssetStakeRoute
  "/staking/$asset/unstake": typeof LayoutStakingAssetUnstakeRoute
  "/defi/portfolio/": typeof LayoutDefiPortfolioIndexRoute
  "/defi/protocols/": typeof LayoutDefiProtocolsIndexRoute
  "/defi/stablecoins/": typeof LayoutDefiStablecoinsIndexRoute
  "/staking/$asset/": typeof LayoutStakingAssetIndexRoute
  "/defi/pool/$tokenAddress/$protocolId": typeof LayoutDefiPoolTokenAddressProtocolIdRoute
}
export interface FileRoutesByTo {
  "/swap": typeof LayoutSwapRoute
  "/": typeof LayoutIndexRoute
  "/portfolio/assets": typeof LayoutPortfolioAssetsRoute
  "/portfolio/breakdown": typeof LayoutPortfolioBreakdownRoute
  "/defi": typeof LayoutDefiIndexRoute
  "/portfolio": typeof LayoutPortfolioIndexRoute
  "/staking": typeof LayoutStakingIndexRoute
  "/defi/portfolio/opportunities": typeof LayoutDefiPortfolioOpportunitiesRoute
  "/defi/portfolio/positions": typeof LayoutDefiPortfolioPositionsRoute
  "/defi/protocols/$protocolKey": typeof LayoutDefiProtocolsProtocolKeyRoute
  "/staking/$asset/claim": typeof LayoutStakingAssetClaimRoute
  "/staking/$asset/stake": typeof LayoutStakingAssetStakeRoute
  "/staking/$asset/unstake": typeof LayoutStakingAssetUnstakeRoute
  "/defi/portfolio": typeof LayoutDefiPortfolioIndexRoute
  "/defi/protocols": typeof LayoutDefiProtocolsIndexRoute
  "/defi/stablecoins": typeof LayoutDefiStablecoinsIndexRoute
  "/staking/$asset": typeof LayoutStakingAssetIndexRoute
  "/defi/pool/$tokenAddress/$protocolId": typeof LayoutDefiPoolTokenAddressProtocolIdRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  "/_layout": typeof LayoutRouteWithChildren
  "/_layout/defi": typeof LayoutDefiRouteWithChildren
  "/_layout/portfolio": typeof LayoutPortfolioRouteWithChildren
  "/_layout/swap": typeof LayoutSwapRoute
  "/_layout/": typeof LayoutIndexRoute
  "/_layout/defi/portfolio": typeof LayoutDefiPortfolioRouteWithChildren
  "/_layout/defi/protocols": typeof LayoutDefiProtocolsRouteWithChildren
  "/_layout/defi/stablecoins": typeof LayoutDefiStablecoinsRouteWithChildren
  "/_layout/portfolio/assets": typeof LayoutPortfolioAssetsRoute
  "/_layout/portfolio/breakdown": typeof LayoutPortfolioBreakdownRoute
  "/_layout/staking/$asset": typeof LayoutStakingAssetRouteWithChildren
  "/_layout/defi/": typeof LayoutDefiIndexRoute
  "/_layout/portfolio/": typeof LayoutPortfolioIndexRoute
  "/_layout/staking/": typeof LayoutStakingIndexRoute
  "/_layout/defi/portfolio/opportunities": typeof LayoutDefiPortfolioOpportunitiesRoute
  "/_layout/defi/portfolio/positions": typeof LayoutDefiPortfolioPositionsRoute
  "/_layout/defi/protocols/$protocolKey": typeof LayoutDefiProtocolsProtocolKeyRoute
  "/_layout/staking/$asset/claim": typeof LayoutStakingAssetClaimRoute
  "/_layout/staking/$asset/stake": typeof LayoutStakingAssetStakeRoute
  "/_layout/staking/$asset/unstake": typeof LayoutStakingAssetUnstakeRoute
  "/_layout/defi/portfolio/": typeof LayoutDefiPortfolioIndexRoute
  "/_layout/defi/protocols/": typeof LayoutDefiProtocolsIndexRoute
  "/_layout/defi/stablecoins/": typeof LayoutDefiStablecoinsIndexRoute
  "/_layout/staking/$asset/": typeof LayoutStakingAssetIndexRoute
  "/_layout/defi/pool/$tokenAddress/$protocolId": typeof LayoutDefiPoolTokenAddressProtocolIdRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | "/defi"
    | "/portfolio"
    | "/swap"
    | "/"
    | "/defi/portfolio"
    | "/defi/protocols"
    | "/defi/stablecoins"
    | "/portfolio/assets"
    | "/portfolio/breakdown"
    | "/staking/$asset"
    | "/defi/"
    | "/portfolio/"
    | "/staking"
    | "/defi/portfolio/opportunities"
    | "/defi/portfolio/positions"
    | "/defi/protocols/$protocolKey"
    | "/staking/$asset/claim"
    | "/staking/$asset/stake"
    | "/staking/$asset/unstake"
    | "/defi/portfolio/"
    | "/defi/protocols/"
    | "/defi/stablecoins/"
    | "/staking/$asset/"
    | "/defi/pool/$tokenAddress/$protocolId"
  fileRoutesByTo: FileRoutesByTo
  to:
    | "/swap"
    | "/"
    | "/portfolio/assets"
    | "/portfolio/breakdown"
    | "/defi"
    | "/portfolio"
    | "/staking"
    | "/defi/portfolio/opportunities"
    | "/defi/portfolio/positions"
    | "/defi/protocols/$protocolKey"
    | "/staking/$asset/claim"
    | "/staking/$asset/stake"
    | "/staking/$asset/unstake"
    | "/defi/portfolio"
    | "/defi/protocols"
    | "/defi/stablecoins"
    | "/staking/$asset"
    | "/defi/pool/$tokenAddress/$protocolId"
  id:
    | "__root__"
    | "/_layout"
    | "/_layout/defi"
    | "/_layout/portfolio"
    | "/_layout/swap"
    | "/_layout/"
    | "/_layout/defi/portfolio"
    | "/_layout/defi/protocols"
    | "/_layout/defi/stablecoins"
    | "/_layout/portfolio/assets"
    | "/_layout/portfolio/breakdown"
    | "/_layout/staking/$asset"
    | "/_layout/defi/"
    | "/_layout/portfolio/"
    | "/_layout/staking/"
    | "/_layout/defi/portfolio/opportunities"
    | "/_layout/defi/portfolio/positions"
    | "/_layout/defi/protocols/$protocolKey"
    | "/_layout/staking/$asset/claim"
    | "/_layout/staking/$asset/stake"
    | "/_layout/staking/$asset/unstake"
    | "/_layout/defi/portfolio/"
    | "/_layout/defi/protocols/"
    | "/_layout/defi/stablecoins/"
    | "/_layout/staking/$asset/"
    | "/_layout/defi/pool/$tokenAddress/$protocolId"
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  LayoutRoute: typeof LayoutRouteWithChildren
}

declare module "@tanstack/react-router" {
  interface FileRoutesByPath {
    "/_layout": {
      id: "/_layout"
      path: ""
      fullPath: ""
      preLoaderRoute: typeof LayoutRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/_layout/": {
      id: "/_layout/"
      path: "/"
      fullPath: "/"
      preLoaderRoute: typeof LayoutIndexRouteImport
      parentRoute: typeof LayoutRoute
    }
    "/_layout/swap": {
      id: "/_layout/swap"
      path: "/swap"
      fullPath: "/swap"
      preLoaderRoute: typeof LayoutSwapRouteImport
      parentRoute: typeof LayoutRoute
    }
    "/_layout/portfolio": {
      id: "/_layout/portfolio"
      path: "/portfolio"
      fullPath: "/portfolio"
      preLoaderRoute: typeof LayoutPortfolioRouteImport
      parentRoute: typeof LayoutRoute
    }
    "/_layout/defi": {
      id: "/_layout/defi"
      path: "/defi"
      fullPath: "/defi"
      preLoaderRoute: typeof LayoutDefiRouteImport
      parentRoute: typeof LayoutRoute
    }
    "/_layout/staking/": {
      id: "/_layout/staking/"
      path: "/staking"
      fullPath: "/staking"
      preLoaderRoute: typeof LayoutStakingIndexRouteImport
      parentRoute: typeof LayoutRoute
    }
    "/_layout/portfolio/": {
      id: "/_layout/portfolio/"
      path: "/"
      fullPath: "/portfolio/"
      preLoaderRoute: typeof LayoutPortfolioIndexRouteImport
      parentRoute: typeof LayoutPortfolioRoute
    }
    "/_layout/defi/": {
      id: "/_layout/defi/"
      path: "/"
      fullPath: "/defi/"
      preLoaderRoute: typeof LayoutDefiIndexRouteImport
      parentRoute: typeof LayoutDefiRoute
    }
    "/_layout/staking/$asset": {
      id: "/_layout/staking/$asset"
      path: "/staking/$asset"
      fullPath: "/staking/$asset"
      preLoaderRoute: typeof LayoutStakingAssetRouteImport
      parentRoute: typeof LayoutRoute
    }
    "/_layout/portfolio/breakdown": {
      id: "/_layout/portfolio/breakdown"
      path: "/breakdown"
      fullPath: "/portfolio/breakdown"
      preLoaderRoute: typeof LayoutPortfolioBreakdownRouteImport
      parentRoute: typeof LayoutPortfolioRoute
    }
    "/_layout/portfolio/assets": {
      id: "/_layout/portfolio/assets"
      path: "/assets"
      fullPath: "/portfolio/assets"
      preLoaderRoute: typeof LayoutPortfolioAssetsRouteImport
      parentRoute: typeof LayoutPortfolioRoute
    }
    "/_layout/defi/stablecoins": {
      id: "/_layout/defi/stablecoins"
      path: "/stablecoins"
      fullPath: "/defi/stablecoins"
      preLoaderRoute: typeof LayoutDefiStablecoinsRouteImport
      parentRoute: typeof LayoutDefiRoute
    }
    "/_layout/defi/protocols": {
      id: "/_layout/defi/protocols"
      path: "/protocols"
      fullPath: "/defi/protocols"
      preLoaderRoute: typeof LayoutDefiProtocolsRouteImport
      parentRoute: typeof LayoutDefiRoute
    }
    "/_layout/defi/portfolio": {
      id: "/_layout/defi/portfolio"
      path: "/portfolio"
      fullPath: "/defi/portfolio"
      preLoaderRoute: typeof LayoutDefiPortfolioRouteImport
      parentRoute: typeof LayoutDefiRoute
    }
    "/_layout/staking/$asset/": {
      id: "/_layout/staking/$asset/"
      path: "/"
      fullPath: "/staking/$asset/"
      preLoaderRoute: typeof LayoutStakingAssetIndexRouteImport
      parentRoute: typeof LayoutStakingAssetRoute
    }
    "/_layout/defi/stablecoins/": {
      id: "/_layout/defi/stablecoins/"
      path: "/"
      fullPath: "/defi/stablecoins/"
      preLoaderRoute: typeof LayoutDefiStablecoinsIndexRouteImport
      parentRoute: typeof LayoutDefiStablecoinsRoute
    }
    "/_layout/defi/protocols/": {
      id: "/_layout/defi/protocols/"
      path: "/"
      fullPath: "/defi/protocols/"
      preLoaderRoute: typeof LayoutDefiProtocolsIndexRouteImport
      parentRoute: typeof LayoutDefiProtocolsRoute
    }
    "/_layout/defi/portfolio/": {
      id: "/_layout/defi/portfolio/"
      path: "/"
      fullPath: "/defi/portfolio/"
      preLoaderRoute: typeof LayoutDefiPortfolioIndexRouteImport
      parentRoute: typeof LayoutDefiPortfolioRoute
    }
    "/_layout/staking/$asset/unstake": {
      id: "/_layout/staking/$asset/unstake"
      path: "/unstake"
      fullPath: "/staking/$asset/unstake"
      preLoaderRoute: typeof LayoutStakingAssetUnstakeRouteImport
      parentRoute: typeof LayoutStakingAssetRoute
    }
    "/_layout/staking/$asset/stake": {
      id: "/_layout/staking/$asset/stake"
      path: "/stake"
      fullPath: "/staking/$asset/stake"
      preLoaderRoute: typeof LayoutStakingAssetStakeRouteImport
      parentRoute: typeof LayoutStakingAssetRoute
    }
    "/_layout/staking/$asset/claim": {
      id: "/_layout/staking/$asset/claim"
      path: "/claim"
      fullPath: "/staking/$asset/claim"
      preLoaderRoute: typeof LayoutStakingAssetClaimRouteImport
      parentRoute: typeof LayoutStakingAssetRoute
    }
    "/_layout/defi/protocols/$protocolKey": {
      id: "/_layout/defi/protocols/$protocolKey"
      path: "/$protocolKey"
      fullPath: "/defi/protocols/$protocolKey"
      preLoaderRoute: typeof LayoutDefiProtocolsProtocolKeyRouteImport
      parentRoute: typeof LayoutDefiProtocolsRoute
    }
    "/_layout/defi/portfolio/positions": {
      id: "/_layout/defi/portfolio/positions"
      path: "/positions"
      fullPath: "/defi/portfolio/positions"
      preLoaderRoute: typeof LayoutDefiPortfolioPositionsRouteImport
      parentRoute: typeof LayoutDefiPortfolioRoute
    }
    "/_layout/defi/portfolio/opportunities": {
      id: "/_layout/defi/portfolio/opportunities"
      path: "/opportunities"
      fullPath: "/defi/portfolio/opportunities"
      preLoaderRoute: typeof LayoutDefiPortfolioOpportunitiesRouteImport
      parentRoute: typeof LayoutDefiPortfolioRoute
    }
    "/_layout/defi/pool/$tokenAddress/$protocolId": {
      id: "/_layout/defi/pool/$tokenAddress/$protocolId"
      path: "/pool/$tokenAddress/$protocolId"
      fullPath: "/defi/pool/$tokenAddress/$protocolId"
      preLoaderRoute: typeof LayoutDefiPoolTokenAddressProtocolIdRouteImport
      parentRoute: typeof LayoutDefiRoute
    }
  }
}

interface LayoutDefiPortfolioRouteChildren {
  LayoutDefiPortfolioOpportunitiesRoute: typeof LayoutDefiPortfolioOpportunitiesRoute
  LayoutDefiPortfolioPositionsRoute: typeof LayoutDefiPortfolioPositionsRoute
  LayoutDefiPortfolioIndexRoute: typeof LayoutDefiPortfolioIndexRoute
}

const LayoutDefiPortfolioRouteChildren: LayoutDefiPortfolioRouteChildren = {
  LayoutDefiPortfolioOpportunitiesRoute: LayoutDefiPortfolioOpportunitiesRoute,
  LayoutDefiPortfolioPositionsRoute: LayoutDefiPortfolioPositionsRoute,
  LayoutDefiPortfolioIndexRoute: LayoutDefiPortfolioIndexRoute,
}

const LayoutDefiPortfolioRouteWithChildren =
  LayoutDefiPortfolioRoute._addFileChildren(LayoutDefiPortfolioRouteChildren)

interface LayoutDefiProtocolsRouteChildren {
  LayoutDefiProtocolsProtocolKeyRoute: typeof LayoutDefiProtocolsProtocolKeyRoute
  LayoutDefiProtocolsIndexRoute: typeof LayoutDefiProtocolsIndexRoute
}

const LayoutDefiProtocolsRouteChildren: LayoutDefiProtocolsRouteChildren = {
  LayoutDefiProtocolsProtocolKeyRoute: LayoutDefiProtocolsProtocolKeyRoute,
  LayoutDefiProtocolsIndexRoute: LayoutDefiProtocolsIndexRoute,
}

const LayoutDefiProtocolsRouteWithChildren =
  LayoutDefiProtocolsRoute._addFileChildren(LayoutDefiProtocolsRouteChildren)

interface LayoutDefiStablecoinsRouteChildren {
  LayoutDefiStablecoinsIndexRoute: typeof LayoutDefiStablecoinsIndexRoute
}

const LayoutDefiStablecoinsRouteChildren: LayoutDefiStablecoinsRouteChildren = {
  LayoutDefiStablecoinsIndexRoute: LayoutDefiStablecoinsIndexRoute,
}

const LayoutDefiStablecoinsRouteWithChildren =
  LayoutDefiStablecoinsRoute._addFileChildren(
    LayoutDefiStablecoinsRouteChildren,
  )

interface LayoutDefiRouteChildren {
  LayoutDefiPortfolioRoute: typeof LayoutDefiPortfolioRouteWithChildren
  LayoutDefiProtocolsRoute: typeof LayoutDefiProtocolsRouteWithChildren
  LayoutDefiStablecoinsRoute: typeof LayoutDefiStablecoinsRouteWithChildren
  LayoutDefiIndexRoute: typeof LayoutDefiIndexRoute
  LayoutDefiPoolTokenAddressProtocolIdRoute: typeof LayoutDefiPoolTokenAddressProtocolIdRoute
}

const LayoutDefiRouteChildren: LayoutDefiRouteChildren = {
  LayoutDefiPortfolioRoute: LayoutDefiPortfolioRouteWithChildren,
  LayoutDefiProtocolsRoute: LayoutDefiProtocolsRouteWithChildren,
  LayoutDefiStablecoinsRoute: LayoutDefiStablecoinsRouteWithChildren,
  LayoutDefiIndexRoute: LayoutDefiIndexRoute,
  LayoutDefiPoolTokenAddressProtocolIdRoute:
    LayoutDefiPoolTokenAddressProtocolIdRoute,
}

const LayoutDefiRouteWithChildren = LayoutDefiRoute._addFileChildren(
  LayoutDefiRouteChildren,
)

interface LayoutPortfolioRouteChildren {
  LayoutPortfolioAssetsRoute: typeof LayoutPortfolioAssetsRoute
  LayoutPortfolioBreakdownRoute: typeof LayoutPortfolioBreakdownRoute
  LayoutPortfolioIndexRoute: typeof LayoutPortfolioIndexRoute
}

const LayoutPortfolioRouteChildren: LayoutPortfolioRouteChildren = {
  LayoutPortfolioAssetsRoute: LayoutPortfolioAssetsRoute,
  LayoutPortfolioBreakdownRoute: LayoutPortfolioBreakdownRoute,
  LayoutPortfolioIndexRoute: LayoutPortfolioIndexRoute,
}

const LayoutPortfolioRouteWithChildren = LayoutPortfolioRoute._addFileChildren(
  LayoutPortfolioRouteChildren,
)

interface LayoutStakingAssetRouteChildren {
  LayoutStakingAssetClaimRoute: typeof LayoutStakingAssetClaimRoute
  LayoutStakingAssetStakeRoute: typeof LayoutStakingAssetStakeRoute
  LayoutStakingAssetUnstakeRoute: typeof LayoutStakingAssetUnstakeRoute
  LayoutStakingAssetIndexRoute: typeof LayoutStakingAssetIndexRoute
}

const LayoutStakingAssetRouteChildren: LayoutStakingAssetRouteChildren = {
  LayoutStakingAssetClaimRoute: LayoutStakingAssetClaimRoute,
  LayoutStakingAssetStakeRoute: LayoutStakingAssetStakeRoute,
  LayoutStakingAssetUnstakeRoute: LayoutStakingAssetUnstakeRoute,
  LayoutStakingAssetIndexRoute: LayoutStakingAssetIndexRoute,
}

const LayoutStakingAssetRouteWithChildren =
  LayoutStakingAssetRoute._addFileChildren(LayoutStakingAssetRouteChildren)

interface LayoutRouteChildren {
  LayoutDefiRoute: typeof LayoutDefiRouteWithChildren
  LayoutPortfolioRoute: typeof LayoutPortfolioRouteWithChildren
  LayoutSwapRoute: typeof LayoutSwapRoute
  LayoutIndexRoute: typeof LayoutIndexRoute
  LayoutStakingAssetRoute: typeof LayoutStakingAssetRouteWithChildren
  LayoutStakingIndexRoute: typeof LayoutStakingIndexRoute
}

const LayoutRouteChildren: LayoutRouteChildren = {
  LayoutDefiRoute: LayoutDefiRouteWithChildren,
  LayoutPortfolioRoute: LayoutPortfolioRouteWithChildren,
  LayoutSwapRoute: LayoutSwapRoute,
  LayoutIndexRoute: LayoutIndexRoute,
  LayoutStakingAssetRoute: LayoutStakingAssetRouteWithChildren,
  LayoutStakingIndexRoute: LayoutStakingIndexRoute,
}

const LayoutRouteWithChildren =
  LayoutRoute._addFileChildren(LayoutRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  LayoutRoute: LayoutRouteWithChildren,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
